class ListingResponseJson {
    constructor(success, message, code, data, errorCode, page, sort) {
        this.success = success;
        this.message = message;
        this.code = code;
        this.data = data;
        this.errorCode = errorCode;
        this.page = page;
        this.sort = sort;
    }
}

export default ListingResponseJson